@use '../../../scss/global/color';
@use '../../../scss/global/spacing';
@use '../../../scss/global/border';
@use '../../../scss/global/typography' as typography;
@use '../../../scss/utils/mixins.scss' as utils-mixins;

.fds-radio-item {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: spacing.$spacer-2;
  padding-block: spacing.$spacer-1;
  background-color: var(--background-color);
  border-radius: border.$radius-1;
  color: var(--text-color);

  @include typography.ui-text-style(400);

  fds-icon {
    border-radius: 9999px;
    color: var(--checkmark-color);
  }

  &--disabled {
    background-color: var(--background-color-disabled);
    color: var(--text-color-disabled);

    fds-icon {
      color: var(--checkmark-color-disabled);
    }
  }

  &--focused:not(&--disabled) {
    fds-icon {
      box-shadow: 0 0 0 2px var(--border-color-focus) inset;
      outline: 2px solid var(--checkmark-border-color-focus, color.$default-blue-100);
    }
  }

  &:hover:not(&--disabled) {
    fds-icon {
      background-color: var(--checkmark-background-color-hover);
    }
  }

  &__input {
    @include utils-mixins.visually-hidden;
  }
}
